// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XcUHz","links":"Nav_links__fu+-7","brand":"Nav_brand__gq7PA"};